<template>
  <div class="calendar-header d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center">
      <h3 class="mb-0 mr-3">
        {{ formattedDate }}
      </h3>
    </div>

    <div class="calendar-controls d-flex">
      <b-button-group>
        <b-button
          variant="outline-primary"
          class="calendar-nav-btn"
          @click="$emit('navigate', 'prev')"
        >
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </b-button>
        <b-button
          variant="outline-primary"
          class="calendar-nav-btn today-btn"
          @click="$emit('navigate', 'today')"
        >
          {{ $t('field.today') }}
        </b-button>
        <b-button
          variant="outline-primary"
          class="calendar-nav-btn"
          @click="$emit('navigate', 'next')"
        >
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
import { BButton, BButtonGroup } from 'bootstrap-vue'

export default {
  name: 'CalendarHeader',
  components: {
    BButton,
    BButtonGroup,
  },
  props: {
    formattedDate: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.calendar-header {
  margin-bottom: 0.75rem;

  h3 {
    font-weight: 600;
    color: #5e5873;
  }
}

.calendar-nav-btn {
  padding: 0.5rem 0.75rem;
  transition: all 0.15s ease;
}

.today-btn {
  font-weight: 600;
  min-width: 80px;
}
</style>